export type ClockSync = {
  serverNow: number;
  localMonotonicAtSync: number;
};

export function estimateServerNow(sync: ClockSync, localMonotonicNow: number): number {
  return sync.serverNow + Math.max(0, localMonotonicNow - sync.localMonotonicAtSync);
}

export function remainingMs(
  endsAt: number,
  sync: ClockSync,
  localMonotonicNow: number
): number {
  return Math.max(0, endsAt - estimateServerNow(sync, localMonotonicNow));
}

export function remainingFromSnapshot(
  remainingAtSync: number,
  sync: ClockSync,
  localMonotonicNow: number
): number {
  return Math.max(0, remainingAtSync - Math.max(0, localMonotonicNow - sync.localMonotonicAtSync));
}
